/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./public.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./public.component";
var styles_PublicComponent = [i0.styles];
var RenderType_PublicComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_PublicComponent, data: {} });
export { RenderType_PublicComponent as RenderType_PublicComponent };
export function View_PublicComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["public works!"]))], null, null); }
export function View_PublicComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-public", [], null, null, null, View_PublicComponent_0, RenderType_PublicComponent)), i1.ɵdid(1, 114688, null, 0, i2.PublicComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var PublicComponentNgFactory = i1.ɵccf("app-public", i2.PublicComponent, View_PublicComponent_Host_0, {}, {}, []);
export { PublicComponentNgFactory as PublicComponentNgFactory };
